<template>
    <section>
        <VideoPoup :videoData="videoData" />
        <div class="row">
            <div class="col-md-3 col-sm-12 cus-sidebar">
                <Sidebar />
            </div>
            <div v-if="isLoading" class="loader">
                <div class="wave-container">
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                    <div class="wave"></div>
                </div>
                <p>Loading...</p>
            </div>  
            <div v-if="!isLoading" class="col-md-9 col-sm-12 right-colm">
                <div class="material-box bg-white module-material-box">
                    <div class="row content-row pb-15">
                        <div class="col-md-12 top-title">
                            <h3> Module {{ moduleData.ModuleNumber }} - {{ moduleData.ModuleName }}</h3>
                        </div>
                        <div class="col-md-12 ">
                            <div class="content-colm row">
                                <div class="col-md-3 pad-15">
                                    <img :src="`${$server_url}images/Modules/${moduleData.ModuleSmallImage}`" alt=""
                                        class=" pendil-img img-fluid">
                                </div>
                                <div class="col-md-9 pad-15">
                                    <p v-html="moduleData.ModuleContent"></p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="clear"></div>
                    <div class="row content-row stretched-content-row" v-for="(week, index) in weeksWithVideosDocuments" :key="index">
                        <div class="col-md-12 title-bar">
                            <h2> Week {{ week.week.WeekNumber }} - <span v-html="week.week.WeekName"></span> 
                            <p>{{ week.week.WeekDescription }}</p>
                            </h2>
                        </div>
                        <div class="content-colm w-content-colm">
                            <div class="full-width">
                                <div class="col-lg-12 col-md-12 col-sm-12">
                                    <div class="material-list">
                                        <h4>Documents</h4>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <ul>
                                                    <li v-for="(document, i) in week.documents" :key="i">
                                                        <span v-if="i < 7">
                                                            <a href="javascript:;" :id="`popover-target${index}${i}`">
                                                                {{ document.DocName }}
                                                            </a>
                                                            <b-popover :target="`popover-target${index}${i}`" triggers="focus"
                                                                placement="right">
                                                                <div class="btn-group" role="group">
                                                                    <!-- <a :href="`${$server_url}Documents/PDF/${document.DocLocation}`" type="button" target="_blank"
                                                                        class="btn yellow-btn">
                                                                        <span class="glyphicon glyphicon-eye-open"></span>
                                                                        View
                                                                    </a> -->
                                                                    <a :href="`${(host == '202.141.226.195') ? 'http://202.141.226.195:8001/storage/documents/8069578_1703609074.pdf' : $server_url+'storage/documents/'+document.DocLocation}`" type="button" target="_blank" class="btn yellow-btn">
                                                                        <span class="glyphicon glyphicon-eye-open"></span>
                                                                        View
                                                                    </a>
                                                                    <a @click.prevent="downloadFile(document.DocLocation, document.DocName)" class="btn blue-btn">
                                                                        <span class="glyphicon glyphicon-cloud-download"></span>
                                                                        Download
                                                                    </a>
                                                                    <!-- <a @click.prevent="downloadFile(document.DocLocation, document.DocName)"
                                                                        class="btn blue-btn">
                                                                        <span
                                                                            class="glyphicon glyphicon-cloud-download"></span>
                                                                        Download
                                                                    </a> -->
                                                                </div>
                                                            </b-popover>
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-md-6">
                                                <ul>
                                                    <li v-for="(document, i) in week.documents" :key="i">
                                                        <span v-if="i >= 7">
                                                            <a href="javascript:;" :id="`popover-target${index}${i}`">
                                                                {{ document.DocName }}
                                                            </a>
                                                            <b-popover :target="`popover-target${index}${i}`" triggers="focus"
                                                                placement="right">
                                                                <div class="btn-group" role="group">
                                                                    <a :href="`${(host == '202.141.226.195') ? 'http://202.141.226.195:8001/storage/documents/8069578_1703609074.pdf' : $server_url+'storage/documents/'+document.DocLocation}`" type="button" target="_blank"
                                                                        class="btn yellow-btn">
                                                                        <span class="glyphicon glyphicon-eye-open"></span>
                                                                        View
                                                                    </a>
                                                                    <a @click.prevent="downloadFile(document.DocLocation, document.DocName)"
                                                                        class="btn blue-btn">
                                                                        <span
                                                                            class="glyphicon glyphicon-cloud-download"></span>
                                                                        Download
                                                                    </a>
                                                                </div>
                                                            </b-popover>
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="material-list video">
                                        <h4>Videos</h4>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <ul>
                                                    <li v-for="(video, ind) in week.videos" :key="ind">
                                                        <span v-if="ind < 6">
                                                            <a class="videomodal pointer"
                                                                @click.prevent="videoModelShow(video.Link)">
                                                                {{ video.VideoName }}
                                                            </a>
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                            <div class="col-md-6">
                                                <ul>
                                                    <li v-for="(video, ind) in week.videos" :key="ind">
                                                        <span v-if="ind >= 6">
                                                            <a class="videomodal pointer"
                                                                @click.prevent="videoModelShow(video.Link)">
                                                                {{ video.VideoName }}
                                                            </a>
                                                        </span>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Sidebar from './components/Sidebar.vue';
import userAPI from '../userApi';
import VideoPoup from './components/VideoPoup.vue';
// import ModuleBox from './components/ModuleBox.vue';

export default {
    name: "Module",
    data() {
        const host = window.location.hostname;
        const port = window.location.port;
        return {
             host,
            port,
            isLoading: false,
            id: "",
            moduleData: {},
            weeksWithVideosDocuments: {},
            videoData:{
                videoSrc:""
            }
        }
    },
    methods: {
        downloadFile(location,name) {
            try {
                userAPI.downloadPdf({ path: window.location.hostname == '202.141.226.195' ? '8069578_1703609074.pdf' : location }, res => {
                    const url = window.URL.createObjectURL(new Blob([res.data]));
                    const link = document.createElement('a');
                    // Adjust the download URL to use the symbolic link
                    link.href = url;
                    link.setAttribute('download', name + ".pdf"); // Set the desired file name and extension
                    link.style.display = 'none';
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                });
            } catch (error) {
                console.error('Error downloading file:', error);
            }
        },
        videoModelShow(src) {
            this.videoData.videoSrc ='https://player.vimeo.com/video/' + src;

            this.$bvModal.show('videoModel');
        },
        documentsVideosWithWeekByModule() {
            userAPI.documentsVideosWithWeekByModule({ moduleID: this.id }, res => {
                this.weeksWithVideosDocuments = res.data.data;
            }, err => {
                console.log(err);
            })
        },
        getModuleById() {
            this.isLoading =true;
            userAPI.getModuleById({ moduleID: this.id }, res => {
                this.moduleData = res.data.data;
                this.documentsVideosWithWeekByModule()
                this.isLoading =false;

            }, err => {
                console.log(err);
                this.isLoading =false;

            })
        }
    },
    mounted() {

        if (this.$route.params.id != undefined && this.$route.params.id != this.id) {
            this.id = this.$route.params.id;
            this.getModuleById()
        }
        // this.id = this.$router.params.id;
    },
    components: {
        Sidebar,
        VideoPoup
    },
    beforeRouteUpdate(to, from, next) {
        // console.log(to.params.id)
        this.id = to.params.id;
        this.getModuleById()
        next();
    }
}
</script>